import React from 'react';

/**
 * 2026-07 remove unused props
 *
 * AgentCredit - shown only to Agents, this tells them who has claimed the
 * cart and allows them to change that, setting themselves as the agent
 * who will receive credit for the order.
 *
 */
export default function AgentCredit({currentAgent, callbacks, shoppingCart}) {
  // only agents may see this.
  if (!currentAgent || !shoppingCart)
    return null;

  if (shoppingCart.agentName)
    return <AgentCreditClaimed
      currentAgent={currentAgent}
      callbacks={callbacks}
    />
  else
    return <AgentCreditUnclaimed
      currentAgent={currentAgent}
      callbacks={callbacks}
    />
}

function AgentCreditClaimed({currentAgent, callbacks}) {
  const {updateCart} = (callbacks || {});

  return <p className={"text-agent-purple"}>
    <span className="fa fa-user-secret"/>
    {' '}
    <strong>{currentAgent.username}</strong>
    {' '}
    will be credited for this sale.
    {' '}
    <a onClick={() => updateCart({agentName: ''})}>(remove)</a>
  </p>
}

function AgentCreditUnclaimed({currentAgent, callbacks}) {
  const {updateCart} = (callbacks || {});
  const {username} = currentAgent;

  const handleClick = () => {
    updateCart({agentName: username})
  }

  return <p className="text-red-800">
    <span className="fa fa-exclamation-triangle"/>
    <strong> No CSR </strong>
    will be credited for this sale.
    {' '}
    <a className="" onClick={handleClick}>
      Click Here to set
      {' '}
      <span className="fa fa-user-secret"/>
      <strong>{username}</strong>
    </a>
    {' '} as the agent responsible for this cart.
  </p>
}
